import { History } from 'history'

import { signout } from '@vacationtracker/shared/services/auth'
import { AppDispatch, logoutAction } from '../../../store/configure'
import { DASHBOARD_SURVEY_STORAGE_KEY } from '../../../types/dashboard'
import { FrontendUrls } from '../../../types/urls'
import { setAuthState } from '../../../store/auth-state-slice'

import { AuthStateEnum } from '@vacationtracker/shared/types/auth-state'
import { getFiltersFromLS, saveFiltersToLS } from '../../../components/reports/types'

interface ILogoutArgument {
  history: History
  reduxDispatch: AppDispatch
  redirectRoute?: string
  userId?: string
  globalSignout?: boolean
}

export const logout = async ({
  history,
  redirectRoute = FrontendUrls.signin,
  reduxDispatch,
  userId,
  globalSignout,
}: ILogoutArgument) => {
  const badgeFeatures = localStorage.getItem('badgeFeatures')
  const dashboardSurvey = localStorage.getItem(DASHBOARD_SURVEY_STORAGE_KEY)
  const onboardingKey = localStorage.getItem('onboardingKey')
  const vtOnboardingV2Progress = localStorage.getItem('vtOnboardingV2Progress')
  const vtApproverOnboardingProgress = localStorage.getItem('vtApproverOnboardingProgress')
  const dashboardFilters = localStorage.getItem(`${userId ? `${userId}#` : ''}dashboardFilters`)
  const wallchartFilters = localStorage.getItem(`${userId ? `${userId}#` : ''}wallchartFilters`)
  const usersFilters = localStorage.getItem(`${userId ? `${userId}#` : ''}usersFilters`)
  const calendarFilters = localStorage.getItem(`${userId ? `${userId}#` : ''}calendarFilters`)
  const userMappings = localStorage.getItem('userMappings')
  const leaveBalanceReportFilters = getFiltersFromLS('leave-balance-report', userId as string)
  const leaveHistoryReportFilters = getFiltersFromLS('leave-history-report', userId as string)
  const leaveBalanceMonthlyReportFilters = getFiltersFromLS('monthly-leave-balance-report', userId as string)
  const leaveBalanceReportTableSettings = localStorage.getItem('leave-balance-reportTableSettings')
  const leaveHistoryReportTableSettings = localStorage.getItem('leave-history-reportTableSettings')
  localStorage.clear()
  const vtOnboardingClosedDate = localStorage.getItem('vtOnboardingClosedDate')
  sessionStorage.clear()
  // since we clear clear local storage
  // we need to keep badge features state in there
  // in order not to show badges on already seen features
  // on the next login
  badgeFeatures && localStorage.setItem('badgeFeatures', badgeFeatures as string)
  dashboardFilters && localStorage.setItem(`${userId ? `${userId}#` : ''}dashboardFilters`, dashboardFilters as string)
  wallchartFilters && localStorage.setItem(`${userId ? `${userId}#` : ''}wallchartFilters`, wallchartFilters as string)
  usersFilters && localStorage.setItem(`${userId ? `${userId}#` : ''}usersFilters`, usersFilters as string)
  calendarFilters && localStorage.setItem(`${userId ? `${userId}#` : ''}calendarFilters`, calendarFilters as string)
  dashboardSurvey && localStorage.setItem(DASHBOARD_SURVEY_STORAGE_KEY, dashboardSurvey as string)
  onboardingKey && localStorage.setItem('onboardingKey', onboardingKey as string)
  // Keep onboarding v2 progress across logouts
  vtOnboardingV2Progress && localStorage.setItem('vtOnboardingV2Progress', vtOnboardingV2Progress as string)
  vtOnboardingClosedDate && localStorage.setItem('vtOnboardingClosedDate', vtOnboardingClosedDate as string)
  vtApproverOnboardingProgress && localStorage.setItem('vtApproverOnboardingProgress', vtApproverOnboardingProgress as string)
  userMappings && localStorage.setItem('userMappings', userMappings as string)
  leaveBalanceReportFilters && saveFiltersToLS(leaveBalanceReportFilters, 'leave-balance-report', userId as string)
  leaveHistoryReportFilters && saveFiltersToLS(leaveHistoryReportFilters, 'leave-history-report', userId as string)
  leaveBalanceMonthlyReportFilters && saveFiltersToLS(leaveBalanceMonthlyReportFilters, 'monthly-leave-balance-report', userId as string)
  leaveBalanceReportTableSettings && localStorage.setItem('leave-balance-reportTableSettings', leaveBalanceReportTableSettings as string)
  leaveHistoryReportTableSettings && localStorage.setItem('leave-history-reportTableSettings', leaveHistoryReportTableSettings as string)
  reduxDispatch(setAuthState(AuthStateEnum.signIn))
  // See Sentry error Jira ticket: https://vacationtracker.atlassian.net/browse/VT-10110
  if (history && history.push) {
    history.push(redirectRoute)
  }
  await signout(globalSignout || false)
  reduxDispatch(logoutAction)
  // See Sentry error Jira ticket: https://vacationtracker.atlassian.net/browse/VT-10110
  if (!history || !history.push) {
    window.location.href = redirectRoute
  }
}
